var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rate-radio"},_vm._l((_vm.content),function(item,index){return _c('div',{staticClass:"ui-radio"},[_c('a',{staticClass:"rate-off",class:_vm.selected[index]?'rate-on rate-ontxt':'',on:{"click":function($event){return _vm.handleRadio(index)}}}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(item))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }